module.exports = __webpack_public_path__ + "img/m_banner1.85359ba8.png";